import React, { FC } from 'react';

import { ControllerProps } from 'react-hook-form/dist/types/props';
import { Select } from '../components/Inputs';
import { useDisciplinesQuery } from '../api';

interface Disciplines extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  filter?: any;
  multiple?: boolean;
  disabled?: boolean;
  onSuperChange?: any;
}

const Disciplines: FC<Disciplines> = ({
  filter = {},
  label,
  error,
  control,
  name,
  rules,
  onSuperChange,
  multiple,
  disabled,
}) => {
  const { data, loading } = useDisciplinesQuery({ variables: { filter } });
  return (
    <Select
      label={label}
      data={data?.dirSportDisciplines || []}
      control={control}
      error={error}
      loading={loading}
      onSuperChange={onSuperChange}
      name={name}
      rules={rules}
      multiple={multiple}
      disabled={disabled}
    />
  );
};

export default Disciplines;
